// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___bc42170361c4ba46d2c","cls2":"SimplePaperPodcast-cls2__d17afb627c69a24abc38 SimplePaperPodcast-cls1___bc42170361c4ba46d2c"};